<div class="wrapper">
  <div class="title">404</div>
  <div class="subtitle">Not Found</div>
</div>
